/* Linaval only. Native product form remains the owner of add-to-cart and errors. */
(() => {
  function init(scope = document) {
    const gallery = scope.querySelector('[data-lin-gallery]');
    if (gallery && !gallery.dataset.ready) {
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.lin-gallery__track');
      const slides = [...track.children];
      const dots = [...gallery.querySelectorAll('[data-gallery-index]')];
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      let current = 0;
      const update = () => {
        current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        gallery.querySelector('[data-gallery-count]').textContent = `${current + 1} / ${slides.length}`;
        prev.disabled = current === 0; next.disabled = current === slides.length - 1;
        dots.forEach((dot, i) => i === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      };
      const go = (index) => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, index)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      prev.addEventListener('click', () => go(current - 1));
      next.addEventListener('click', () => go(current + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      track.addEventListener('keydown', e => {if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); go(current + (e.key === 'ArrowRight' ? 1 : -1));}});
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track); update();
    }
    scope.querySelectorAll('[data-lin-tabs]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[role="tab"]')];
      const select = tab => {
        tabs.forEach(t => {const chosen = t === tab; t.setAttribute('aria-selected', String(chosen)); t.tabIndex = chosen ? 0 : -1; document.getElementById(t.getAttribute('aria-controls')).hidden = !chosen;});
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', e => {
          let n;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== undefined) {e.preventDefault(); select(tabs[n]); tabs[n].focus();}
        });
      });
      select(tabs[0]);
    });
    const sticky = document.querySelector('[data-lin-sticky]');
    const steps = document.getElementById('l2steps');
    const form = document.querySelector('.product-information product-form-component form') || document.querySelector('product-form-component form');
    const button = form?.querySelector('button[name="add"], add-to-cart-component button');
    if (sticky && steps && button && !sticky.dataset.ready) {
      sticky.dataset.ready = 'true';
      const cta = sticky.querySelector('button');
      const update = () => {
        const selected = steps.querySelector('.l2st-card.is-active');
        sticky.querySelector('[data-sticky-price]').textContent = selected?.querySelector('.l2st-now')?.textContent || '';
        sticky.querySelector('[data-sticky-option]').textContent = selected?.querySelector(steps.dataset.purchaseMode === 'sub' ? '.l2st-cadence' : '.l2st-t')?.textContent || sticky.dataset.productTitle || 'Linaval';
        cta.disabled = button.disabled;
        cta.textContent = button.disabled ? (button.textContent.includes('Agotado') ? 'Agotado' : 'Añadiendo…') : 'Añadir al carrito';
      };
      new MutationObserver(update).observe(steps, {subtree: true, attributes: true, childList: true, characterData: true});
      new MutationObserver(update).observe(button, {attributes: true, childList: true, subtree: true});
      // Show after the purchase area, never cover the initial gallery or the native CTA.
      const updateVisibility = () => {
        const banner = document.querySelector('#shopify-pc__banner');
        sticky.hidden = button.getBoundingClientRect().bottom >= 0 || Boolean(banner?.getClientRects().length);
      };
      let visibilityFrame = 0;
      window.addEventListener('scroll', () => {
        if (!visibilityFrame) visibilityFrame = requestAnimationFrame(() => {visibilityFrame = 0; updateVisibility();});
      }, {passive: true});
      window.addEventListener('resize', updateVisibility, {passive: true});
      new IntersectionObserver(updateVisibility).observe(button);
      cta.addEventListener('click', () => {if (!button.disabled) button.click();}); update(); updateVisibility();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
